module.exports = __webpack_public_path__ + "static/media/phone.655d3314.gif";